/** External product URLs — update when CellarHost gets its own domain. */
export const CELLARHOST_URL =
    process.env.REACT_APP_CELLARHOST_URL ||
    "https://salescan-estate-concierge.vercel.app";

export const STATIC_SERVICE_PATHS = {
    hvacRecovery: "/hvac-recovery/",
};
